const uuidv4 = require('uuid/v4')
let dcopy = require('deep-copy')
let jse = require('jsencrypt')

export const fMuuid = function () {
  return uuidv4().split('-').join('')
}

export const sortTypes = ['text', 'date', 'dateTime', 'dateTime', 'number']

export const clSortDatas = function ({datas, sortType, funSort, type, key}) {
  if (datas.length < 2) {
    return datas
  }
  let useFun = null
  if (funSort) {
    useFun = funSort
  } else if (sortType === 'text') {
    useFun = sortText
  } else if (sortType === 'date') {
    useFun = sortDate
  } else {
    useFun = sortNumber
  }
  for (let indexA in datas) {
    for (let indexB in datas) {
      let nIndexB = Number(indexB)
      if (nIndexB < (datas.length - 1 - indexA) && useFun(datas[nIndexB][key], datas[nIndexB + 1][key], type)) {
        [datas[nIndexB], datas[nIndexB + 1]] = [datas[nIndexB + 1], datas[nIndexB]]
      }
    }
  }
  return datas
}

export const findDataFormTree = ({data, dataKey, tree, childKey}) => {
  let findItem = null
  tree.forEach((item) => {
    if (item[dataKey] === data) {
      findItem = item
    } else if (!findItem && item[childKey] && item[childKey].length > 0) {
      findItem = findDataFormTree({data, dataKey, tree: item[childKey], childKey})
    }
  })
  return findItem
}

export const rsaEncrypt = (gy, text) => {
  let jseJm = new jse.JSEncrypt()
  jseJm.setPublicKey(gy)
  return jseJm.encrypt(text)
}

export const rsaDecrypt = (sy, text) => {
  let jseJm = new jse.JSEncrypt()
  jseJm.setPrivateKey(sy)
  return jseJm.decrypt(text)
}

export const getUrlParm = () => {
  let data = {}
  let url = window.location.href
  let urlList = url.split('?')
  let parmStr = urlList && urlList.length === 2 ? urlList[1] : null
  if (parmStr) {
    let parmStrList = parmStr.split('&')
    parmStrList.forEach((item) => {
      let parmItemList = item.split('=')
      if (parmItemList && parmItemList.length === 2) {
        data[parmItemList[0]] = parmItemList[1]
      }
    })
  }
  return data
}

const sortText = function (a, b, type) {
  return type === 'desc' ? (a > b) : (a < b)
}

export const testPassword = (password) => {
  let reData = 'ok'
  if (typeof password !== 'string') {
    reData = 'noString'
  } else if (password.length < 12) {
    reData = 'noLong'
  } else if (!password.match(/[a-z]/g) && !password.match(/[A-Z]/g)) {
    reData = 'noAbc'
  } else if (!password.match(/[0-9]/g)) {
    reData = 'noNum'
  } else {
    reData = new RegExp("[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【_】‘；：”“'。，、？]").test(password) ? 'ok' : 'noChart'
  }
  return reData
}

export const downFile = (content, filename) => {
  let eleLink = document.createElement('a')
  eleLink.download = filename
  eleLink.style.display = 'none'
  // 字符内容转变成blob地址
  eleLink.href = URL.createObjectURL(new Blob([content]))
  // 触发点击
  document.body.appendChild(eleLink)
  eleLink.click()
  // 然后移除
  document.body.removeChild(eleLink)
}

export const downFileByUrl = (url, filename) => {
  let eleLink = document.createElement('a')
  eleLink.download = filename
  eleLink.style.display = 'none'
  eleLink.href = window.location.origin + url
  // 触发点击
  document.body.appendChild(eleLink)
  eleLink.click()
  // 然后移除
  document.body.removeChild(eleLink)
}

const sortNumber = function (a, b, type) {
  a = Number(a) || 0
  b = Number(b) || 0
  return type === 'desc' ? (a > b) : (a < b)
}

const sortDate = function (a, b, type) {
  let newA = new Date(a).getTime()
  let newB = new Date(b).getTime()
  return type === 'desc' ? (newA > newB) : (newA < newB)
}

export const dateOperating = {
  // 当前时间加减几天days, hours
  computeDay: function ({format = 'number', days = 0, date} = {format: 'number', days: 0}) {
    if (typeof date === 'string') {
      date = date.length === 10 ? (date + 'T00:00') : date
      if (date.slice(10, 11) === ' ') {
        date = date.slice(0, 10) + 'T' + date.slice(11)
      }
    }
    let nowDate = new Date(dcopy(date)) || new Date()
    if (days && days !== 0) {
      nowDate.setDate(nowDate.getDate() + days)
    }
    return this.formatDate({
      date: nowDate.getTime(),
      format: format
    })
  },
  formatDate: function ({date = null, format = 'number', days = 0} = {date: null, format: 'number', days: 0}) {
    if (!date) {
      return null
    }
    if (typeof date === 'string') {
      date = date.replace('T', ' ')
      date = date.replace(/-/g, '/')
    }
    date = date ? new Date(date) : new Date()
    let month = (date.getMonth() + 1) > 9 ? (date.getMonth() + 1) : String(0) + (date.getMonth() + 1)
    let day = date.getDate() > 9 ? date.getDate() : String(0) + date.getDate()
    let hour = date.getHours() > 9 ? date.getHours() : String(0) + date.getHours()
    let minute = date.getMinutes() > 9 ? date.getMinutes() : String(0) + date.getMinutes()
    let year = date.getFullYear()
    let seconds = date.getSeconds() > 9 ? date.getSeconds() : String(0) + date.getSeconds()
    if (format === 'yy-mm-dd') {
      return year + '-' + month + '-' + day
    } else if (format === 'yy/mm/dd') {
      return year + '/' + month + '/' + day
    } else if (format === 'yy年mm月dd日') {
      return year + '年' + month + '月' + day + '日'
    } else if (format === 'm-d hh:mm') {
      return (date.getMonth() + 1) + '-' + date.getDate() + ' ' + hour + ':' + minute
    } else if (format === 'm-d') {
      return (date.getMonth() + 1) + '-' + date.getDate()
    } else if (format === 'yy.mm.dd') {
      return year + '.' + month + '.' + day
    } else if (format === 'yy-mm-dd hh:mm') {
      return year + '-' + month + '-' + day + ' ' + hour + ':' + minute
    } else if (format === 'yy-mm-dd hh:mm:ss') {
      return year + '-' + month + '-' + day + ' ' + hour + ':' + minute + ':' + seconds
    } else if (format === 'hh:mm') {
      return hour + ':' + minute
    } else if (format === 'stamps') {
      return date.getTime()
    } else if (format === 'mm-dd hh:mm:ss') {
      return month + '-' + day + ' ' + hour + ':' + minute + ':' + seconds
    } else {
      return new Date(date.getTime())
    }
  },
  getMonthDays: function (year, month) {
    if (!year || !month) {
      return 0
    }
    year = Number(year)
    month = Number(month)
    let date1 = new Date(year + '/' + month + '/01 00:00:00')
    let date2Year = month === 12 ? year + 1 : year
    let date2Month = month === 12 ? 1 : month + 1
    let date2 = new Date(date2Year + '/' + date2Month + '/01 00:00:00')
    return (date2.getTime() - date1.getTime()) / 1000 / 60 / 60 / 24
  },
  checkSameDay: function (date1, date2) {
    date2 = date2 || new Date()
    return this.formatDate({date: date1, format: 'yy-mm-dd'}) === this.formatDate({date: date2, format: 'yy-mm-dd'})
  },
  minusDate: function (d1 = new Date(), d2 = new Date()) {
    return d1.getTime() - d2.getTime()
  },
  intervalDays: function (dateStr) {
    let date = new Date(dateStr).getDate()
    let date2 = new Date().getDate()
    return date - date2
  }
}



// WEBPACK FOOTER //
// ./src/cllib/tools.js